// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fc a {
  color: #000000 !important;
}
.fc .fc-toolbar {
  flex-wrap: wrap;
  flex-direction: row !important;
}
.fc .fc-toolbar .fc-prev-button,
.fc .fc-toolbar .fc-next-button {
  display: inline-block;
  background-color: transparent;
  border-color: transparent;
}
.fc .fc-toolbar .fc-prev-button .fc-icon,
.fc .fc-toolbar .fc-next-button .fc-icon {
  color: #987d5d;
}
.fc .fc-toolbar .fc-prev-button:hover, .fc .fc-toolbar .fc-prev-button:active, .fc .fc-toolbar .fc-prev-button:focus,
.fc .fc-toolbar .fc-next-button:hover,
.fc .fc-toolbar .fc-next-button:active,
.fc .fc-toolbar .fc-next-button:focus {
  background-color: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}
.fc .fc-toolbar .fc-prev-button {
  padding-left: 5 !important;
}
.fc .fc-toolbar .fc-toolbar-chunk:first-child {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.fc .fc-toolbar .fc-button {
  padding: 0.438rem 0.5rem;
}
.fc .fc-toolbar .fc-button:active, .fc .fc-toolbar .fc-button:focus {
  box-shadow: none;
}
.fc .fc-toolbar .fc-button-primary:not(.fc-prev-button):not(.fc-next-button) {
  background-color: #ce7d22 !important;
  border-color: #425b4e;
  color: #000000;
  font-weight: bold;
  border-width: 0px;
}
.fc .fc-toolbar .fc-button-primary:not(.fc-prev-button):not(.fc-next-button).fc-button-active, .fc .fc-toolbar .fc-button-primary:not(.fc-prev-button):not(.fc-next-button):hover {
  background-color: rgb(70, 92, 80) !important;
  border-color: #3d544b !important;
  color: #000000;
  cursor: pointer;
}
.fc .fc-toolbar .fc-button-primary.fc-sidebarToggle-button {
  border: 0;
}
.fc .fc-toolbar .fc-button-primary.fc-sidebarToggle-button i,
.fc .fc-toolbar .fc-button-primary.fc-sidebarToggle-button svg {
  height: 21px;
  width: 21px;
  font-size: 21px;
}
.fc .fc-toolbar .fc-button-group .fc-button {
  text-transform: capitalize;
}
.fc .fc-toolbar .fc-button-group .fc-button:focus {
  box-shadow: none;
}
.fc .fc-toolbar .fc-button-group .fc-sidebarToggle-button {
  padding-left: 0;
  background-color: transparent !important;
  color: #987d5d !important;
}
.fc .fc-toolbar .fc-button-group .fc-sidebarToggle-button:not(.fc-prev-button):not(.fc-next-button):hover {
  background-color: transparent !important;
}
.fc .fc-toolbar .fc-button-group .fc-sidebarToggle-button + div {
  margin-left: 0;
}
.fc .fc-toolbar .fc-button-group .fc-dayGridMonth-button,
.fc .fc-toolbar .fc-button-group .fc-timeGridWeek-button,
.fc .fc-toolbar .fc-button-group .fc-timeGridDay-button,
.fc .fc-toolbar .fc-button-group .fc-listMonth-button,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineDay-button,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineWeek-button,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineMonth-button,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineYear-button,
.fc .fc-toolbar .fc-button-group .fc-listWeek-button {
  padding: 0.55rem 1.5rem;
}
.fc .fc-toolbar .fc-button-group .fc-dayGridMonth-button:last-child, .fc .fc-toolbar .fc-button-group .fc-dayGridMonth-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridWeek-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridWeek-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridDay-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridDay-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-listMonth-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-listMonth-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineDay-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineDay-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineWeek-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineWeek-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineMonth-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineMonth-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineYear-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineYear-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-listWeek-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-listWeek-button:first-child {
  border-radius: 0.358rem;
}
.fc .fc-toolbar .fc-button-group .fc-dayGridMonth-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridWeek-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridDay-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-listMonth-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineDay-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineWeek-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineMonth-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineYear-button:first-child,
.fc .fc-toolbar .fc-button-group .fc-listWeek-button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.fc .fc-toolbar .fc-button-group .fc-dayGridMonth-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridWeek-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-timeGridDay-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-listMonth-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineDay-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineWeek-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineMonth-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-resourceTimelineYear-button:last-child,
.fc .fc-toolbar .fc-button-group .fc-listWeek-button:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.fc .fc-toolbar > * > :not(:first-child) {
  margin-left: 0rem;
}
.fc .fc-toolbar .fc-toolbar-title {
  margin-left: 0.25rem;
  color: #000000;
}
.fc .fc-toolbar .fc--button:empty,
.fc .fc-toolbar .fc-toolbar-chunk:empty {
  display: none;
}
.fc tbody td,
.fc thead th {
  border-color: #425b4e;
}
.fc tbody td.fc-col-header-cell,
.fc thead th.fc-col-header-cell {
  border: 1px solid #425b4e;
  padding: 0.75rem 0.5rem;
}
.fc .fc-daygrid .fc-scrollgrid-section-body table {
  height: 100vh !important;
}
.fc .fc-view-harness {
  height: calc(100vh - 280px) !important;
}
.fc .fc-timeline-event .fc-event-main {
  max-height: 50px;
  overflow: hidden;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
}
.fc .fc-timeline-event-harness {
  padding-bottom: 2px;
}
.fc .fc-scrollgrid-section-liquid > td {
  border-bottom: 0;
}
.fc .fc-daygrid-event-harness .fc-event {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
}
.fc .fc-daygrid-day-bottom {
  margin-top: 0.3rem;
}
.fc .fc-dayGridMonth-view .fc-daygrid-day {
  height: 130px;
}
.fc .fc-daygrid-day {
  padding: 5px;
}
.fc .fc-daygrid-day .fc-daygrid-day-top {
  flex-direction: row;
}
.fc .fc-more-popover {
  max-height: 35%;
  overflow-y: auto;
}
.fc .fc-daygrid-day-number,
.fc .fc-timegrid-slot-label-cushion,
.fc .fc-list-event-time {
  color: #987d5d;
}
.fc .fc-day-today {
  background: #ce7d22 !important;
  background-color: #ce7d22 !important;
}
.fc .fc-timegrid .fc-scrollgrid-section .fc-col-header-cell,
.fc .fc-timegrid .fc-scrollgrid-section .fc-timegrid-axis {
  border-color: #425b4e;
  border-left: 0;
  border-right: 0;
}
.fc .fc-timegrid .fc-scrollgrid-section .fc-timegrid-axis {
  border-color: #425b4e;
}
.fc .fc-timegrid .fc-timegrid-axis.fc-scrollgrid-shrink .fc-timegrid-axis-cushion {
  text-transform: capitalize;
  color: #3a5044;
}
.fc .fc-timegrid .fc-timegrid-slots .fc-timegrid-slot {
  height: 3rem;
}
.fc .fc-timegrid .fc-timegrid-slots .fc-timegrid-slot .fc-timegrid-slot-label-frame {
  text-align: center;
}
.fc .fc-timegrid .fc-timegrid-slots .fc-timegrid-slot .fc-timegrid-slot-label-frame .fc-timegrid-slot-label-cushion {
  text-transform: uppercase;
}
.fc .fc-timegrid .fc-timegrid-divider {
  display: none;
}
.fc .fc-list {
  border-color: #425b4e;
}
.fc .fc-list .fc-list-day-cushion {
  background: #ce7d22 !important;
}
.fc .fc-list .fc-list-event:hover td {
  background-color: #ce7d22 !important;
}
.fc .fc-list .fc-list-event td {
  border-color: #425b4e;
}

.app-calendar {
  position: relative;
  border-radius: 0.428rem;
}
.app-calendar .app-calendar-sidebar {
  position: absolute;
  left: calc(-18rem - 1.2rem);
  width: 18rem;
  height: 100%;
  z-index: 5;
  background-color: #987d5d;
  border-right: 1px solid #425b4e;
  flex-basis: 18rem;
  transition: all 0.2s, background 0s, border 0s;
}
.app-calendar .app-calendar-sidebar.show {
  left: 0;
}
.app-calendar .app-calendar-sidebar .sidebar-content-title {
  font-size: 0.85rem;
  color: #3a5044;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.app-calendar .app-calendar-sidebar .select-all ~ label,
.app-calendar .app-calendar-sidebar .input-filter ~ label {
  color: #465c50;
  font-weight: 500;
  letter-spacing: 0.4px;
}
.app-calendar .event-sidebar {
  position: absolute;
  top: 0;
  right: 0;
  width: 400px;
  z-index: 15;
  transform: translateX(120%);
  transition: all 0.3s ease-in-out;
}
.app-calendar .event-sidebar .card {
  height: calc(100vh - 12.96rem);
  height: calc(var(--vh, 1vh) * 100 - 12.96rem);
  border-radius: 0 0.25rem 0.25rem 0;
}
.app-calendar .event-sidebar .card .close-bar {
  cursor: pointer;
}
.app-calendar .event-sidebar .card .todo-item-action {
  width: 6rem;
}
.app-calendar .event-sidebar .card .todo-item-action .todo-item-info,
.app-calendar .event-sidebar .card .todo-item-action .todo-item-favorite,
.app-calendar .event-sidebar .card .todo-item-action .dropdown {
  cursor: pointer;
  line-height: 1.5;
}
.app-calendar .event-sidebar .card .todo-item-action .dropdown .dropdown-menu .dropdown-item {
  padding: 0.14rem 1.428rem;
}
.app-calendar .event-sidebar .card .todo-item-action .dropdown-toggle::after {
  display: none;
}
.app-calendar .event-sidebar.show {
  transform: translateX(0);
}
.app-calendar .fc-toolbar h2 {
  font-size: 1.45rem;
}
.app-calendar .fc-header-toolbar {
  margin-bottom: 1.75rem !important;
}
.app-calendar .fc-view-harness {
  margin: 0 -1.6rem;
}
.app-calendar .fc-scrollgrid {
  border-color: #425b4e;
}
.app-calendar .fc-day-past .fc-daygrid-day-number,
.app-calendar .fc-day-future .fc-daygrid-day-number {
  color: #3a5044;
}
.app-calendar .fc-popover {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  border: 2px solid #425b4e;
}
.app-calendar .fc-popover .fc-popover-header {
  background: transparent;
  padding: 0.5rem;
}
.app-calendar .fc-popover .fc-popover-header .fc-popover-title,
.app-calendar .fc-popover .fc-popover-header .fc-popover-close {
  color: #000000;
}
.app-calendar .fc-popover .fc-popover-body *:not(:last-of-type) {
  margin-bottom: 0.3rem;
}
.app-calendar .fc .fc-event {
  padding: 0px;
  padding-left: 2px;
  background: #5a6f67;
}
.app-calendar .fc .fc-event .fc-event-main {
  color: inherit;
}
.app-calendar .fc-list-event {
  background: transparent !important;
}
@media (min-width: 992px) {
  .app-calendar .app-calendar-sidebar {
    position: static;
    height: auto;
    box-shadow: none !important;
  }
  .app-calendar .app-calendar-sidebar .flatpickr-days {
    background-color: transparent;
  }
}

.event-sidebar .select2-selection__choice__remove:before {
  top: 40% !important;
}

.horizontal-layout .app-calendar {
  margin-bottom: 1rem;
}

@media (max-width: 992px) {
  .fc .fc-sidebarToggle-button {
    font-size: 0;
  }
}
@media (min-width: 992px) {
  .fc .fc-sidebarToggle-button {
    display: none;
  }
}
@media (max-width: 700px) {
  .app-calendar .fc .fc-header-toolbar .fc-toolbar-chunk:last-of-type {
    margin-top: 1rem;
  }
  .app-calendar .fc .fc-view-harness {
    height: calc(100vh - 315px) !important;
  }
}
.event-sidebar .badge:empty {
  display: inline-block;
}
.event-sidebar .react-select {
  z-index: 2;
}

html[dir=rtl] .fc.fc-direction-rtl .fc-scroller-harness > .fc-scroller {
  direction: ltr !important;
}
html[dir=rtl] .fc .fc-header-toolbar .fc-prev-button,
html[dir=rtl] .fc .fc-header-toolbar .fc-next-button {
  transform: rotate(180deg);
}
html[dir=rtl] .fc .fc-toolbar .fc-button-group .fc-dayGridMonth-button:first-child {
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
html[dir=rtl] .fc .fc-toolbar .fc-button-group .fc-listMonth-button:last-child {
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
html[dir=rtl] .fc .fc-event-main-frame {
  flex-direction: row-reverse !important;
}
html[dir=rtl] .fc .fc-popover {
  margin-right: 6.2rem;
}
html[dir=rtl] .fc .fc-daygrid-day-bottom {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/app-calendar-base.scss","webpack://./src/assets/scss/app-calendar.scss","webpack://./src/assets/scss/color-base.scss"],"names":[],"mappings":"AAmBE;EACE,yBAAA;AClBJ;ADqBE;EACE,eAAA;EACA,8BAAA;ACnBJ;ADqBI;;EAEE,qBAAA;EACA,6BAAA;EACA,yBAAA;ACnBN;ADqBM;;EACE,cEfK;ADHb;ADqBM;;;;EAGE,wCAAA;EACA,oCAAA;EACA,2BAAA;AClBR;ADsBI;EACE,0BAAA;ACpBN;ADuBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;ACrBN;ADwBI;EACE,wBAhDmB;AC0BzB;ADwBM;EAEE,gBAAA;ACvBR;AD4BM;EACE,oCE9CE;EF+CF,qBEhDO;EFiDP,cEjEG;EFkEH,iBAAA;EACA,iBAAA;AC1BR;AD4BQ;EAEE,4CEjDE;EFkDF,gCEjDS;EFkDT,cExEC;EF0ED,eAAA;AC3BV;AD+BM;EACE,SAAA;AC7BR;AD+BQ;;EAEE,YAAA;EACA,WAAA;EACA,eAAA;AC7BV;ADmCM;EACE,0BAAA;ACjCR;ADmCQ;EACE,gBAAA;ACjCV;ADqCM;EACE,eAAA;EACA,wCAAA;EACA,yBAAA;ACnCR;ADqCQ;EACE,wCAAA;ACnCV;ADsCQ;EACE,cAAA;ACpCV;ADwCM;;;;;;;;;EASE,uBArHoB;AC+E5B;ADwCQ;;;;;;;;;;;;;;;;;EAEE,uBAxHU;ACiGpB;AD0BQ;;;;;;;;;EACE,0BAAA;EACA,6BAAA;AChBV;ADmBQ;;;;;;;;;EACE,yBAAA;EACA,4BAAA;ACTV;ADcI;EACE,iBAAA;ACZN;ADeI;EACE,oBAAA;EACA,cElJK;ADqIX;ADgBI;;EAEE,aAAA;ACdN;ADmBE;;EAEE,qBEhJW;AD+Hf;ADmBI;;EACE,yBAAA;EACA,uBAAA;AChBN;ADqBI;EACE,wBAAA;ACnBN;ADuBE;EACE,sCAAA;ACrBJ;ADwBE;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;ACtBJ;ADyBE;EACE,mBAAA;ACvBJ;AD4BE;EACE,gBAAA;AC1BJ;AD8BI;EACE,iBApMe;EAqMf,gBAtMiB;EAuMjB,uBAAA;AC5BN;ADiCE;EACE,kBAAA;AC/BJ;ADoCI;EACE,aAAA;AClCN;ADsCE;EACE,YAAA;ACpCJ;ADqCI;EACE,mBAAA;ACnCN;ADuCE;EACE,eAAA;EACA,gBAAA;ACrCJ;ADyCE;;;EAGE,cEzNS;ADkLb;AD0CE;EACE,8BE3NM;EF4NN,oCE5NM;ADoLV;AD+CM;;EAEE,qBEtOO;EFuOP,cAAA;EACA,eAAA;AC7CR;ADgDM;EACE,qBE5OO;AD8Lf;ADoDQ;EACE,0BAAA;EACA,cElPG;ADgMb;ADwDM;EACE,YAAA;ACtDR;ADwDQ;EACE,kBAAA;ACtDV;ADwDU;EACE,yBAAA;ACtDZ;AD4DI;EACE,aAAA;AC1DN;AD+DE;EACE,qBE9QW;ADiNf;AD+DI;EACE,8BEhRI;ADmNV;ADkEQ;EACE,oCEtRA;ADsNV;ADoEM;EACE,qBE5RO;AD0Nf;;ADyEA;EACE,kBAAA;EACA,uBA7SmB;ACuOrB;ADyEE;EACE,kBAAA;EACA,2BAAA;EACA,YA3Te;EA4Tf,YAAA;EACA,UAAA;EACA,yBE3SM;EF4SN,+BAAA;EACA,iBAhUe;EAiUf,8CAAA;ACvEJ;ADyEI;EACE,OAAA;ACvEN;AD0EI;EACE,kBAAA;EACA,cEvTO;EFwTP,yBAAA;EACA,qBAAA;ACxEN;AD6EM;;EACE,cE5TS;EF6TT,gBAAA;EACA,qBAAA;AC1ER;ADgFE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,gCAAA;AC9EJ;ADgFI;EACE,8BAAA;EACA,6CAAA;EACA,kCAAA;AC9EN;ADgFM;EACE,eAAA;AC9ER;ADiFM;EACE,WAAA;AC/ER;ADiFQ;;;EAGE,eAAA;EACA,gBAAA;AC/EV;ADkFQ;EACE,yBAAA;AChFV;ADmFQ;EACE,aAAA;ACjFV;ADsFI;EACE,wBAAA;ACpFN;ADyFI;EACE,kBAAA;ACvFN;AD2FE;EACE,iCAAA;ACzFJ;AD4FE;EACE,iBAAA;AC1FJ;AD6FE;EACE,qBEnYW;ADwSf;ADgGI;;EACE,cEvYO;AD0Sb;ADiGE;EACE,8CAnZS;EAoZT,yBAAA;AC/FJ;ADgGI;EACE,uBAAA;EACA,eAAA;AC9FN;ADgGM;;EAEE,cEpaG;ADsUX;ADmGM;EACE,qBAAA;ACjGR;ADuGI;EACE,YAAA;EACA,iBAAA;EACA,mBE7ZK;ADwTX;ADsGM;EACE,cAAA;ACpGR;ADyGE;EACE,kCAAA;ACvGJ;AD0GE;EACE;IACE,gBAAA;IACA,YAAA;IACA,2BAAA;ECxGJ;ED0GI;IACE,6BAAA;ECxGN;AACF;;ADgHI;EACE,mBAAA;AC7GN;;ADoHE;EACE,mBAAA;ACjHJ;;ADsHA;EAEI;IACE,YAAA;ECpHJ;AACF;ADwHA;EAEI;IACE,aAAA;ECvHJ;AACF;AD2HA;EAIQ;IACE,gBAAA;EC5HR;EDgII;IACE,sCAAA;EC9HN;AACF;AA1XE;EACE,qBAAA;AA4XJ;AA1XE;EACE,UAAA;AA4XJ;;AApXI;EACE,yBAAA;AAuXN;AApXM;;EAEE,yBAAA;AAsXR;AAlXM;EACE,uCAAA;EACA,0CAAA;EACA,oCAAA;EACA,uCAAA;AAoXR;AAlXM;EACE,sCAAA;EACA,yCAAA;EACA,qCAAA;EACA,wCAAA;AAoXR;AAjXI;EACE,sCAAA;AAmXN;AAjXI;EACE,oBAAA;AAmXN;AAjXI;EACE,gBAAA;AAmXN","sourcesContent":["// Core variables and mixins\r\n@import './color-base.scss';\r\n\r\n$fc-calendar-height: 650px;\r\n$fc-sidebar-width: 18rem;\r\n$fc-event-font-weight: 600;\r\n$fc-event-font-size: 0.8rem;\r\n$fc-event-padding-x: 0.5rem;\r\n$fc-event-padding-y: 0.25rem;\r\n$fc-toolbar-btn-padding: 0.438rem 0.5rem;\r\n$fc-day-toggle-btn-padding: 0.55rem 1.5rem;\r\n$btn-border-radius: 0.358rem !default;\r\n$card-border-radius: 0.428rem !default;\r\n$border-radius-lg: 0.6rem !default;\r\n$border-radius-sm: 0.25rem !default;\r\n$box-shadow: 0 4px 24px 0 rgba($black, 0.1) !default;\r\n\r\n// Full calendar styles\r\n.fc {\r\n  a {\r\n    color: $gray-150 !important;\r\n  }\r\n  // Toolbar\r\n  .fc-toolbar {\r\n    flex-wrap: wrap;\r\n    flex-direction: row !important;\r\n\r\n    .fc-prev-button,\r\n    .fc-next-button {\r\n      display: inline-block;\r\n      background-color: transparent;\r\n      border-color: transparent;\r\n\r\n      .fc-icon {\r\n        color: $body-color;\r\n      }\r\n\r\n      &:hover,\r\n      &:active,\r\n      &:focus {\r\n        background-color: transparent !important;\r\n        border-color: transparent !important;\r\n        box-shadow: none !important;\r\n      }\r\n    }\r\n\r\n    .fc-prev-button {\r\n      padding-left: 5 !important;\r\n    }\r\n\r\n    .fc-toolbar-chunk:first-child {\r\n      display: flex;\r\n      align-items: center;\r\n      flex-wrap: wrap;\r\n    }\r\n\r\n    .fc-button {\r\n      padding: $fc-toolbar-btn-padding;\r\n\r\n      &:active,\r\n      &:focus {\r\n        box-shadow: none;\r\n      }\r\n    }\r\n\r\n    .fc-button-primary {\r\n      &:not(.fc-prev-button):not(.fc-next-button) {\r\n        background-color: $body-bg;\r\n        border-color: $border-color;\r\n        color: $gray-100;\r\n        font-weight: bold;\r\n        border-width: 0px;\r\n\r\n        &.fc-button-active,\r\n        &:hover {\r\n          background-color: $hover-btn;\r\n          border-color: $hover-btn-border;\r\n          color: $gray-150;\r\n          cursor: pointer;\r\n          cursor: pointer;\r\n        }\r\n      }\r\n\r\n      &.fc-sidebarToggle-button {\r\n        border: 0;\r\n\r\n        i,\r\n        svg {\r\n          height: 21px;\r\n          width: 21px;\r\n          font-size: 21px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .fc-button-group {\r\n      .fc-button {\r\n        text-transform: capitalize;\r\n\r\n        &:focus {\r\n          box-shadow: none;\r\n        }\r\n      }\r\n\r\n      .fc-sidebarToggle-button {\r\n        padding-left: 0;\r\n        background-color: transparent !important;\r\n        color: $body-color  !important;\r\n\r\n        &:not(.fc-prev-button):not(.fc-next-button):hover {\r\n          background-color: transparent !important;\r\n        }\r\n\r\n        &+div {\r\n          margin-left: 0;\r\n        }\r\n      }\r\n\r\n      .fc-dayGridMonth-button,\r\n      .fc-timeGridWeek-button,\r\n      .fc-timeGridDay-button,\r\n      .fc-listMonth-button,\r\n      .fc-resourceTimelineDay-button,\r\n      .fc-resourceTimelineWeek-button,\r\n      .fc-resourceTimelineMonth-button,\r\n      .fc-resourceTimelineYear-button,\r\n      .fc-listWeek-button {\r\n        padding: $fc-day-toggle-btn-padding;\r\n\r\n        &:last-child,\r\n        &:first-child {\r\n          border-radius: $btn-border-radius;\r\n        }\r\n\r\n        &:first-child {\r\n          border-top-right-radius: 0;\r\n          border-bottom-right-radius: 0;\r\n        }\r\n\r\n        &:last-child {\r\n          border-top-left-radius: 0;\r\n          border-bottom-left-radius: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    &>*> :not(:first-child) {\r\n      margin-left: 0rem;\r\n    }\r\n\r\n    .fc-toolbar-title {\r\n      margin-left: 0.25rem;\r\n      color: $gray-200;\r\n    }\r\n\r\n    .fc--button:empty,\r\n    .fc-toolbar-chunk:empty {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  // Calendar head & body common\r\n  tbody td,\r\n  thead th {\r\n    border-color: $border-color;\r\n\r\n    &.fc-col-header-cell {\r\n      border: 1px solid  $border-color;\r\n      padding: 0.75rem 0.5rem;\r\n    }\r\n  }\r\n\r\n  .fc-daygrid {\r\n    .fc-scrollgrid-section-body table {\r\n      height: 100vh !important\r\n    }\r\n  }\r\n\r\n  .fc-view-harness {\r\n    height: calc(100vh - 280px) !important;\r\n  }\r\n\r\n  .fc-timeline-event .fc-event-main {\r\n    max-height: 50px;\r\n    overflow: hidden;\r\n    flex-grow: 1;\r\n    flex-shrink: 1;\r\n    min-width: 0;\r\n  }\r\n\r\n  .fc-timeline-event-harness {\r\n    padding-bottom: 2px;\r\n  }\r\n\r\n\r\n  // Daygrid\r\n  .fc-scrollgrid-section-liquid>td {\r\n    border-bottom: 0;\r\n  }\r\n\r\n  .fc-daygrid-event-harness {\r\n    .fc-event {\r\n      font-size: $fc-event-font-size;\r\n      font-weight: $fc-event-font-weight;\r\n      padding: $fc-event-padding-y $fc-event-padding-x;\r\n    }\r\n\r\n  }\r\n\r\n  .fc-daygrid-day-bottom {\r\n    margin-top: 0.3rem;\r\n  }\r\n\r\n  .fc-dayGridMonth-view  {\r\n\r\n    .fc-daygrid-day {\r\n      height: 130px;\r\n    }\r\n  }\r\n\r\n  .fc-daygrid-day {\r\n    padding: 5px;\r\n    .fc-daygrid-day-top {\r\n      flex-direction: row;\r\n    }\r\n  }\r\n\r\n  .fc-more-popover {\r\n    max-height: 35%;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  // All Views Event\r\n  .fc-daygrid-day-number,\r\n  .fc-timegrid-slot-label-cushion,\r\n  .fc-list-event-time {\r\n    color: $body-color;\r\n  }\r\n\r\n  .fc-day-today {\r\n    background: $body-bg;\r\n    background-color: $body-bg;\r\n  }\r\n\r\n  // Timegrid\r\n  .fc-timegrid {\r\n    .fc-scrollgrid-section {\r\n\r\n      .fc-col-header-cell,\r\n      .fc-timegrid-axis {\r\n        border-color: $border-color;\r\n        border-left: 0;\r\n        border-right: 0;\r\n      }\r\n\r\n      .fc-timegrid-axis {\r\n        border-color: $border-color;\r\n      }\r\n    }\r\n\r\n    .fc-timegrid-axis {\r\n      &.fc-scrollgrid-shrink {\r\n        .fc-timegrid-axis-cushion {\r\n          text-transform: capitalize;\r\n          color: $text-muted;\r\n        }\r\n      }\r\n    }\r\n\r\n    .fc-timegrid-slots {\r\n      .fc-timegrid-slot {\r\n        height: 3rem;\r\n\r\n        .fc-timegrid-slot-label-frame {\r\n          text-align: center;\r\n\r\n          .fc-timegrid-slot-label-cushion {\r\n            text-transform: uppercase;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .fc-timegrid-divider {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  // List View\r\n  .fc-list {\r\n    border-color: $border-color;\r\n\r\n    .fc-list-day-cushion {\r\n      background: $body-bg;\r\n    }\r\n\r\n    .fc-list-event {\r\n      &:hover {\r\n        td {\r\n          background-color: $body-bg;\r\n        }\r\n      }\r\n\r\n      td {\r\n        border-color: $border-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// App Calendar specific\r\n.app-calendar {\r\n  position: relative;\r\n  border-radius: $card-border-radius;\r\n  // margin-bottom: 2rem;\r\n\r\n  .app-calendar-sidebar {\r\n    position: absolute;\r\n    left: calc(-#{$fc-sidebar-width} - 1.2rem);\r\n    width: $fc-sidebar-width;\r\n    height: 100%;\r\n    z-index: 5;\r\n    background-color: $card-bg;\r\n    border-right: 1px solid $border-color;\r\n    flex-basis: $fc-sidebar-width;\r\n    transition: all 0.2s, background 0s, border 0s;\r\n\r\n    &.show {\r\n      left: 0;\r\n    }\r\n\r\n    .sidebar-content-title {\r\n      font-size: 0.85rem;\r\n      color: $text-muted;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.6px;\r\n    }\r\n\r\n    .select-all,\r\n    .input-filter {\r\n      &~label {\r\n        color: $headings-color;\r\n        font-weight: 500;\r\n        letter-spacing: 0.4px;\r\n      }\r\n    }\r\n  }\r\n\r\n  // right sidebar area styles\r\n  .event-sidebar {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    width: 400px;\r\n    z-index: 15;\r\n    transform: translateX(120%);\r\n    transition: all 0.3s ease-in-out;\r\n\r\n    .card {\r\n      height: calc(100vh - 12.96rem);\r\n      height: calc(var(--vh, 1vh) * 100 - 12.96rem);\r\n      border-radius: 0 $border-radius-sm $border-radius-sm 0;\r\n\r\n      .close-bar {\r\n        cursor: pointer;\r\n      }\r\n\r\n      .todo-item-action {\r\n        width: 6rem;\r\n\r\n        .todo-item-info,\r\n        .todo-item-favorite,\r\n        .dropdown {\r\n          cursor: pointer;\r\n          line-height: 1.5;\r\n        }\r\n\r\n        .dropdown .dropdown-menu .dropdown-item {\r\n          padding: 0.14rem 1.428rem;\r\n        }\r\n\r\n        .dropdown-toggle::after {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.show {\r\n      transform: translateX(0);\r\n    }\r\n  }\r\n\r\n  .fc-toolbar {\r\n    h2 {\r\n      font-size: 1.45rem;\r\n    }\r\n  }\r\n\r\n  .fc-header-toolbar {\r\n    margin-bottom: 1.75rem !important;\r\n  }\r\n\r\n  .fc-view-harness {\r\n    margin: 0 -1.6rem;\r\n  }\r\n\r\n  .fc-scrollgrid {\r\n    border-color: $border-color;\r\n  }\r\n\r\n  .fc-day-past,\r\n  .fc-day-future {\r\n    .fc-daygrid-day-number {\r\n      color: $text-muted;\r\n    }\r\n  }\r\n\r\n  .fc-popover {\r\n    box-shadow: $box-shadow;\r\n    border: 2px solid $border-color;\r\n    .fc-popover-header {\r\n      background: transparent;\r\n      padding: 0.5rem;\r\n\r\n      .fc-popover-title,\r\n      .fc-popover-close {\r\n        color: $gray-200;\r\n      }\r\n    }\r\n\r\n    .fc-popover-body {\r\n      *:not(:last-of-type) {\r\n        margin-bottom: 0.3rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .fc {\r\n    .fc-event {\r\n      padding: 0px;\r\n      padding-left: 2px;\r\n      background: $event-bg;\r\n      .fc-event-main {\r\n        color: inherit;\r\n      }\r\n    }\r\n  }\r\n\r\n  .fc-list-event {\r\n    background: transparent !important;\r\n  }\r\n\r\n  @media (min-width: 992px) {\r\n    .app-calendar-sidebar {\r\n      position: static;\r\n      height: auto;\r\n      box-shadow: none !important;\r\n\r\n      .flatpickr-days {\r\n        background-color: transparent;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Event Sidebar\r\n.event-sidebar {\r\n  .select2-selection__choice__remove {\r\n    &:before {\r\n      top: 40% !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Horizontal Menu\r\n.horizontal-layout {\r\n  .app-calendar {\r\n    margin-bottom: 1rem;\r\n  }\r\n}\r\n\r\n// Media Queries\r\n@media (max-width: 992px) {\r\n  .fc {\r\n    .fc-sidebarToggle-button {\r\n      font-size: 0;\r\n    }\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .fc {\r\n    .fc-sidebarToggle-button {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .app-calendar {\r\n    .fc {\r\n      .fc-header-toolbar {\r\n        .fc-toolbar-chunk:last-of-type {\r\n          margin-top: 1rem;\r\n        }\r\n      }\r\n\r\n      .fc-view-harness {\r\n        height: calc(100vh - 315px) !important;\r\n      }\r\n    \r\n    }\r\n  }\r\n}\r\n","// App Calendar\r\n// ========================================================================\r\n@import './app-calendar-base.scss';\r\n\r\n.event-sidebar {\r\n  .badge:empty {\r\n    display: inline-block;\r\n  }\r\n  .react-select {\r\n    z-index: 2;\r\n  }\r\n}\r\n\r\n$border-radius: 2px;\r\n\r\nhtml[dir='rtl'] {\r\n  .fc {\r\n    &.fc-direction-rtl .fc-scroller-harness > .fc-scroller {\r\n      direction: ltr !important;\r\n    }\r\n    .fc-header-toolbar {\r\n      .fc-prev-button,\r\n      .fc-next-button {\r\n        transform: rotate(180deg);\r\n      }\r\n    }\r\n    .fc-toolbar .fc-button-group {\r\n      .fc-dayGridMonth-button:first-child {\r\n        border-top-right-radius: $border-radius !important;\r\n        border-bottom-right-radius: $border-radius !important;\r\n        border-top-left-radius: 0 !important;\r\n        border-bottom-left-radius: 0 !important;\r\n      }\r\n      .fc-listMonth-button:last-child {\r\n        border-top-left-radius: $border-radius !important;\r\n        border-bottom-left-radius: $border-radius !important;\r\n        border-top-right-radius: 0 !important;\r\n        border-bottom-right-radius: 0 !important;\r\n      }\r\n    }\r\n    .fc-event-main-frame {\r\n      flex-direction: row-reverse !important;\r\n    }\r\n    .fc-popover {\r\n      margin-right: 6.2rem;\r\n    }\r\n    .fc-daygrid-day-bottom {\r\n      text-align: left;\r\n    }\r\n  }\r\n}\r\n","$white: #fff !default;\r\n\r\n// Khaki Shades\r\n$gray-50: #f0ead6 !default; // Very light khaki\r\n$gray-100: #000000 !default; // Lightest khaki\r\n$gray-150: #000000 !default; // Calendar Dates\r\n$gray-200: #000000 !default; // Calendar Title\r\n$gray-300: #b6b261 !default; // Light khaki\r\n$gray-400: #a8a545 !default;\r\n$gray-500: #999829 !default;\r\n$gray-600: #8b8b0d !default; // Standard khaki\r\n$gray-700: #7d7d00 !default;\r\n$gray-800: #6f6f00 !default; // Dark khaki\r\n$gray-900: #616100 !default; // Darkest khaki\r\n\r\n// Keeping black as is\r\n$black: #22292f !default;\r\n\r\n// Navy Green Accents\r\n$body-color: #987d5d !default; // \r\n$border-color: #425b4e !default; // borders\r\n$body-bg: #ce7d22 !important !default; // Header Color \r\n$text-muted: #3a5044 !default; // Muted navy green for less important text\r\n$card-bg: #987d5d; // Light navy green for card backgrounds\r\n$card-body: #b79e82; // BODY WHERE MESSAGES TRANSMIT\r\n$headings-color: #465c50 !default; // Darker navy green for headings\r\n$hover-btn: rgb(70, 92, 80) !important; // Dark navy green for button hover\r\n$hover-btn-border: #3d544b !important; // Darker navy green for button hover border\r\n$event-bg: #5a6f67 !default; // Translucent navy green for event backgrounds\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
